
 
 <div class="scanner-shell" [hidden]="!hasDevices">

  <!-- <mat-menu #appMenu="matMenu">
    <mat-selection-list>
      <mat-list-option checkboxPosition="start" (click)="toggleTryHarder()" [selected]="tryHarder">
        Enable Try-harder
      </mat-list-option>
      <mat-list-option checkboxPosition="start" (click)="toggleTorch()" [selected]="torchEnabled"
        *ngIf="torchAvailable$ | async">
        Enable Torch
      </mat-list-option>
    </mat-selection-list>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openFormatsDialog()">Barcode formats</button>
    <button mat-menu-item (click)="openInfoDialog()">App info</button>
  </mat-menu>

  <header>
    <mat-form-field appearance="fill">
      <mat-select [value]="deviceSelected" (valueChange)="onDeviceSelectChange($event)">
        <mat-option value="">No Device Selected</mat-option>
        <mat-option *ngFor="let device of availableDevices" [value]="device.deviceId">{{device.label}}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button [matMenuTriggerFor]="appMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </header> -->

  
  <zxing-scanner [torch]="torchEnabled" [device]="deviceCurrent" (deviceChange)="onDeviceChange($event)" (scanSuccess)="onCodeResult($event)"
  [formats]="formatsEnabled" [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
  (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>
  
       <section class="results" *ngIf="qrResultString">
        <div>
          <small>Result</small>
          <strong>{{ qrResultString }}</strong>
        </div>
        <button  (click)="clearResult()">&times;</button>
      </section>
    
 </div>
 
<!-- </div> -->


<!-- <div > -->
    <!-- <div class="col-12 pd flex">  -->

      <!-- <div class="col-12 "> -->
<!--         
          <select class="select2 form-control custom-select" style="width: 100%; height:36px;">
            <option (click)="toggleTryHarder()" [selected]="tryHarder" >Select</option>
            <optgroup  *ngFor="let device of availableDevices" [value]="device.deviceId">
               <option value="">No Device Selected</option>
                <option >{{device.label}}</option>
            </optgroup>
        </select>
        

      </div>
        
      
      <div class="col-1">
        <div class="row">
          <button type="button" class="btn btn-danger btn-circle " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [value]="deviceSelected" (valueChange)="onDeviceSelectChange($event)">
            <i class="fa fa-list"></i> 
            <div class="dropdown-menu animated flipInY">

              <a class="dropdown-item" href="#" (click)="toggleTryHarder()" >Action</a>
              <a class="dropdown-item" href="#" (click)="toggleTorch()" >Action</a>
              <li role="separator" class="divider"></li>
              <button  (click)="openFormatsDialog()">Barcode formats</button>
              <button  (click)="openInfoDialog()">App info</button>

          </div>
          </button>
        </div>
      </div> -->


   

    <!-- </div> -->



<!-- <div class="btn-group">
  <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="ti-trash"></i>
  </button>
  <div class="dropdown-menu animated flipInY">
      <a class="dropdown-item" href="#">Action</a>
      <a class="dropdown-item" href="#">Another action</a>
      <a class="dropdown-item" href="#">Something else here</a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="#">Separated link</a>
  </div>
</div> -->







<ng-container *ngIf="hasPermission === undefined">

  <h2>Waiting for permissions.</h2>

  <blockquote>
    If your device does not has cameras, no permissions will be asked.
  </blockquote>

</ng-container>

<ng-container *ngIf="hasPermission === false">

  <h2>You denied the camera permission, we can't scan anything without it. 😪</h2>

</ng-container>

<ng-container *ngIf="hasDevices === undefined">

  <h2>Couldn't check for devices.</h2>

  <blockquote>
    This may be caused by some security error.
  </blockquote>

</ng-container>

<ng-container *ngIf="hasDevices === false">

  <h2>No devices were found.</h2>

  <blockquote>
    I believe your device has no media devices attached to.
  </blockquote>

</ng-container>
